import { render } from "./Twitch.vue?vue&type=template&id=e1fadd4a"
const script = {}
script.render = render

export default script